module.exports = __webpack_public_path__ + "img/z-qrcode2.b2db7011.jpg";